import slugify from 'slugify';


const renderSubContractorRows = (subContractors) => {
    let html = '';

    subContractors.forEach((item, index) => {
        const sent = item.sent;
        const status = !item.sent ? 'Not Sent' : item.status_verbose;
        const uploadedDockets = item.uploaded_dockets ? '<i class="far fa-file-invoice"></i>' : '';
        const rego = item.registered_vehicle ? item.registered_vehicle : 'N/A';

        html +=
            `<tr id="${item.id}">
                <td>${(index + 1).toString().padStart(3, '0')}</td>
                <td>${item.sub_contractor_details.company_name}</td>
                <td>${item.sub_contractor_details.first_name} ${item.sub_contractor_details.last_name}</td>
                <td>${rego}</td>
                <td class="text-center">
                    <span class="status status--${slugify(status, {lower:true})}">
                        ${uploadedDockets} ${status}
                    </span>
                </td>
                <td class="text-center">
                    <a
                    class="btn btn--toggle 
                    ${item.respond_to_job_reminders ? 'active' : ''} 
                    toggleDriverReminders"
                    data-id="${item.id}"
                    data-value="${item.respond_to_job_reminders}"
                    data-action="toggleDriverReminders"
                    >
                        <i class="far fa-alarm-clock"></i>
                    </a>
                </td>
                <td class="text-center">
                    <a
                    class="btn btn--toggle 
                    ${item.docket_notifications ? 'active' : ''} 
                    toggleDocketUploadedReminders"
                    data-id="${item.id}"
                    data-value="${item.docket_notifications}"
                    data-action="toggleAdminNotifications"
                    >
                        <i class="far fa-receipt"></i>
                    </a>
                </td>
                <td class="text-end">
                    <div class="form__check">
                        <input class="send-to-driver form-check-input" type="checkbox" value="${item.id}">
                    </div>
                    <div class="options-menu">
                        <button
                                class="btn dropdown-toggle"
                                type="button" id="dropdownMenuButton${item.id}"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                        >
                            <i class="far fa-ellipsis-h"></i>
                        </button>
                        <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton${item.id}"
                        >
                            <li>
                                <a class="dropdown-item" href="/job/upload-dockets/${item.uuid}" target="_blank">
                                    Upload / Remove Dockets
                                </a>
                                <a
                                        class="dropdown-item danger"
                                        href="#confirmRemoveContractorModal"
                                        data-bs-toggle="modal"
                                        data-id="${item.id}"
                                        data-name="${item.sub_contractor_details.first_name} ${item.sub_contractor_details.last_name}"
                                >
                                    Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>`;
    });

    return html;
}

export default renderSubContractorRows;
